import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

import * as fromOrganizations from './organization.reducer';
import * as fromDepartments from './departments.reducer';
import * as fromRoles from './roles.reducer';
import * as fromUnits from './units.reducer';
import * as fromModules from './modules.reducer';
import * as fromPermissions from './permissions.reducer';
import * as fromTemplates from './templates.reducer';

import { Params } from '@angular/router';

export interface RouterUrl {
  url: string;
  queryParams: Params;
  params: Params;
}

export interface StateRoot {
  routerReducer: fromRouter.RouterReducerState<RouterUrl>;
}

export interface DashboardState {
  organization: fromOrganizations.OrganizationState;
  departments: fromDepartments.DepartmentState;
  roles: fromRoles.RoleState;
  units: fromUnits.UnitState;
  modules: fromModules.ModuleState;
  permissions: fromPermissions.PermissionState;
  templates: fromTemplates.TemplateState;
}
export interface State extends StateRoot {
  dashboard: DashboardState;
}

export const reducers: ActionReducerMap<DashboardState> = {
  organization: fromOrganizations.reducer,
  departments: fromDepartments.reducer,
  roles: fromRoles.reducer,
  units: fromUnits.reducer,
  modules: fromModules.reducer,
  permissions: fromPermissions.reducer,
  templates: fromTemplates.reducer
};

export const getFilterState = createFeatureSelector<DashboardState>('dashboard');
